import { GroupPendingIntro } from '@/assets/icons/notification';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { NotificationCard } from '../components/Card';
import { Intro } from './GetIntro';

export const GroupIntro = ({ notification = {} }) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <NotificationCard notification={notification} skipMark={true}>
      <Flex borderBottom={`${showMore ? '1px solid #e5e5e5' : ''} `} pb="12px">
        <Icon as={GroupPendingIntro} width="40px" height="40px" />
        <Box ml="12px" pos="relative">
          <Flex pr="12px">
            <Text>
              You have
              <Text
                as="span"
                px="4px"
                fontWeight="semiBold"
              >{`${notification?.group?.length} intro requests`}</Text>
              pending. Get them off your to-do list. Approve or deny in a click.
            </Text>
          </Flex>
          <Box mt="12px">
            <Button
              onClick={() =>
                window.open(`/dashboard?tab=circles&pending-make=true`, '_self')
              }
              data-test-id="review-intro-requests-button"
            >
              Review intro requests
            </Button>
          </Box>
        </Box>
      </Flex>
      <Box>
        {showMore && (
          <Box mt="12px" pl="30px">
            {notification?.group?.map((notification) => (
              <Intro notification={notification} key={notification?.id} />
            ))}
          </Box>
        )}

        <Box mt="12px">
          <Text
            color="#0043CE"
            fontWeight="semiBold"
            cursor="pointer"
            onClick={() => setShowMore((prev) => !prev)}
          >
            {`${
              !showMore
                ? `+ ${notification?.group?.length} notifications`
                : 'show less'
            }`}
          </Text>
        </Box>
      </Box>
    </NotificationCard>
  );
};
